import { render } from "./SetTestRanges.vue?vue&type=template&id=0ba223d8&scoped=true"
import script from "./SetTestRanges.js?vue&type=script&lang=js"
export * from "./SetTestRanges.js?vue&type=script&lang=js"

import "./SetTestRanges.vue?vue&type=style&index=0&id=0ba223d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba223d8"]])

export default __exports__